/**
 * Extract spreadsheet document id from a Google Sheet URL.
 */
export function extractGoogleSpreadsheetId(
    spreadsheetUrl: string | null | undefined
): string | null {
    if (!spreadsheetUrl?.trim()) return null;
    const m = spreadsheetUrl.trim().match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
    return m ? m[1] : null;
}

/**
 * Full Google Sheets editor (menus, toolbars, tabs) — use for the main Finz workspace iframe.
 * Same-browser Google session required; Google may block some embeds by policy.
 */
export function buildGoogleSheetFullEditorUrl(
    spreadsheetUrl: string | null | undefined
): string | null {
    const id = extractGoogleSpreadsheetId(spreadsheetUrl);
    if (!id) return null;
    return `https://docs.google.com/spreadsheets/d/${id}/edit`;
}

/**
 * Compact embed for the details drawer (reduced chrome).
 */
export function buildGoogleSheetEmbedUrl(
    spreadsheetUrl: string | null | undefined
): string | null {
    const id = extractGoogleSpreadsheetId(spreadsheetUrl);
    if (!id) return null;
    return `https://docs.google.com/spreadsheets/d/${id}/edit?rm=minimal&widget=true&headers=false&chrome=false`;
}
